import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function AdminAuthenticated({ children }) {
  const { userData } = useSelector(state => state.reducer);

  if (!userData || Object.keys(userData).length === 0) {
    return <Navigate to="/" replace />;
  }

  if (userData.role === "SUPERADMIN" || userData.role === "COORDINATOR") {
    return children;
  }

  return <Navigate to="/dashboard?menu=dashboard" replace />;
}

export function UserAuthenticated({ children }) {
  const { userData } = useSelector(state => state.reducer);

  if (!userData || Object.keys(userData).length === 0) {
    return <Navigate to="/" replace />;
  }

  if (userData.role === "USER") {
    return children;
  }

  return <Navigate to="/dashboard?menu=dashboard" replace />;
}

export default AdminAuthenticated;
